module.exports = __webpack_public_path__ + "img/sdg_icon_wheel.95da29cc.png";